const o = {
  "loading-icon": "loading-icon"
};
export {
  o as default
};
